import styled from '@emotion/styled';

const StyledLanguageSelectWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 0;
`;

const StyledLanguageSelectOuterWrapper = styled.div`
  position: relative;
  top: 0;
  width: 100%;
  height: 32px;
`;

export { StyledLanguageSelectWrapper, StyledLanguageSelectOuterWrapper };
